var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Tabs',{attrs:{"selected":_vm.tabs.selected,"tabs":_vm.tabs.list},on:{"select":_vm.selectTab},scopedSlots:_vm._u([{key:"content-userList",fn:function(){return [_c('user-list')]},proxy:true},(_vm.pendingApprovals)?{key:"content-pendingApprovals",fn:function(){return [_c('pending-approvals')]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }